import { DateService, DateTimeFormat } from '@cxstudio/services/date-service.service';

app.filter('dateFormat', (dateService: DateService) => {
	return (dateFormat: DateTimeFormat) => dateService.getUserDateFormat(dateFormat);
});
